import CustomText from "@components/CustomText";
import color from "@constants/color";
import React from "react";
import { Image, TouchableOpacity, View, StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import Text from "@components/AppText";
import Info from "@assets/svg/MyDeliveries/Info";
import PaymentAndIssueTags from "./PaymentAndIssueTags";
import ItemsToReturnStrip from "./ItemsToReturnStrip";
import CxDetail from "./CxDetail";
import Tag from "@components/Tag";

const NewTag = () => {
  return (
    <View style={styles.newTag}>
      <Text style={styles.newTagText}>नया</Text>
    </View>
  );
};

const CxCard = ({
  item,
  date,
  spokeName,
  setInfoTooltipData,
  setInfoTooltipVisible,
  type,
  createCall,
}) => {
  const navigation = useNavigation();

  const itemListText = () => {
    let res = "";
    if (
      item?.noOfCrates > 0 &&
      item?.noOfShipments > 0 &&
      item?.noOfOpenItems > 0
    )
      res = `${item?.noOfCrateItems} क्रेट आइटम्स • ${item?.noOfShipments} पैकेट्स • ${item?.noOfOpenItems} Open आइटम्स`;
    else if (item?.noOfCrates > 0 && item?.noOfShipments > 0)
      res = `${item?.noOfCrateItems} क्रेट आइटम्स • ${item?.noOfShipments} पैकेट्स`;
    else if (item?.noOfCrates > 0 && item?.noOfOpenItems > 0)
      res = `${item?.noOfCrateItems} क्रेट आइटम्स • ${item?.noOfOpenItems} Open आइटम्स`;
    else if (item?.noOfShipments > 0 && item?.noOfOpenItems > 0)
      res = `${item?.noOfShipments} पैकेट्स • ${item?.noOfOpenItems} Open आइटम्स`;
    else if (item?.noOfCrates > 0) res = `${item?.noOfCrateItems} क्रेट आइटम्स`;
    else if (item?.noOfShipments > 0) res = `${item?.noOfShipments} पैकेट्स`;
    else if (item?.noOfOpenItems > 0)
      res = `${item?.noOfOpenItems} Open आइटम्स`;
    else res = "";

    if (item?.noOfCdcBags > 0) {
      res +=
        res.length > 0
          ? ` • ${item?.noOfCdcBags} बैग्स`
          : `${item?.noOfCdcBags} बैग्स`;
    }
    if (item?.noOfTopSkuItems > 0) {
      res +=
        res.length > 0
          ? ` • ${item?.noOfTopSkuItems} Inventory Items`
          : `${item?.noOfTopSkuItems} Inventory Items`;
    }
    return res;
  };

  const onInfoPress = () => {
    setInfoTooltipVisible(true);
    setInfoTooltipData({
      title: "पैकेट्स",
      list: item?.shipments_list || [],
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.cxInfoContainer}>
        {item?.new_user && <NewTag />}
        <CxDetail item={item} date={date} createCall={createCall} />
        <View style={styles.itemDetails}>
          <View style={styles.itemText}>
            <CustomText
              variant="body_text_4"
              style={{ color: color.mediumBlacklightBlack }}
            >
              {itemListText()}
            </CustomText>
            {item?.noOfShipments > 0 && (
              <TouchableOpacity
                testID="info"
                onPress={() => onInfoPress()}
                style={styles.infoButton}
              >
                <Info />
              </TouchableOpacity>
            )}
          </View>
          <View style={styles.items}>
            <View style={styles.itemImageContainer}>
              {item?.order_items &&
                Array.isArray(item?.order_items) &&
                item.order_items.map((v, i) => {
                  if (i < 3) {
                    return (
                      <View key={v} style={styles.imageView}>
                        <Image
                          style={styles.image}
                          source={{
                            uri: v.product_image,
                          }}
                        />
                        {v.quantity > 1 && (
                          <View style={styles.itemCount}>
                            <CustomText
                              variant="caption_4"
                              style={{ color: color.mediumBlack }}
                            >
                              {v.quantity}
                            </CustomText>
                          </View>
                        )}
                      </View>
                    );
                  }
                  return null;
                })}
              {item?.order_items &&
                Array.isArray(item?.order_items) &&
                item?.order_items.length - 3 > 0 && (
                  <CustomText
                    variant="body_text_4"
                    style={{ color: color.mediumBlacklightBlack }}
                  >
                    {`+${item?.order_items.length - 3}`}
                  </CustomText>
                )}
            </View>
            <TouchableOpacity
              testID="seeItems"
              onPress={() => {
                navigation.navigate("CrateItemList", {
                  user_name: item?.user_name,
                  orders_list: item?.orders_list,
                  user_id: item?.user_id,
                  user_phone: item?.user_phone,
                  date,
                  spokeName,
                  type,
                });
              }}
            >
              <View
                style={[
                  styles.itemDekhe,
                  item?.all_orders_submitted
                    ? styles.itemDekheSubmitted
                    : styles.itemDekheActive,
                ]}
              >
                <CustomText
                  variant="subtitle_16"
                  style={{
                    color: item?.all_orders_submitted
                      ? color.black
                      : color.white,
                  }}
                >
                  {item?.all_orders_freezed
                    ? "आइटम्स देखें"
                    : item?.all_orders_submitted
                      ? "बदलाव करें"
                      : "आइटम्स देखें"}
                </CustomText>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
      {item?.COD ? <PaymentAndIssueTags payment={item?.COD} /> : null}
      {item?.PREPAID ? <PaymentAndIssueTags payment={item?.PREPAID} /> : null}
      {item?.plastic_bag_opted_in ? (
        <View style={styles.plasticBagContainer}>
          <Tag text="Bags Required" />
        </View>
      ) : null}
      {item?.return_quantity ? (
        <View style={styles.returnQuantity}>
          <ItemsToReturnStrip return_quantity={item?.return_quantity} />
        </View>
      ) : null}
    </View>
  );
};

export default CxCard;

const COLORS = {
  white: "#ffffff",
  imageBorder: "rgba(0, 0, 0, 0.10)",
  countBorder: "rgba(0, 0, 0, 0.20)",
  dekheBorder: "rgba(0, 0, 0, 0.20)",
  newTagText: "#FFFFFF",
  newTagBg: "#00BA6E",
};

const styles = StyleSheet.create({
  container: {
    elevation: 2,
    marginTop: 8,
    backgroundColor: color.white,
    overflow: "hidden",
  },
  cxInfoContainer: {
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  itemDetails: { paddingVertical: 12 },
  itemText: { flexDirection: "row" },
  itemImageContainer: { flexDirection: "row", alignItems: "center" },
  infoButton: { padding: 2 },
  plasticBagContainer: { paddingHorizontal: 8, paddingBottom: 6 },
  imageView: {
    width: 56,
    height: 56,
    padding: 8,
    borderColor: color.lighterBlack,
    borderWidth: 0.5,
    borderRadius: 8,
    marginRight: 8,
  },
  image: { height: 40, width: 40 },
  items: {
    marginTop: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  itemCount: {
    position: "absolute",
    width: 20,
    height: 20,
    alignItems: "center",
    borderColor: color.black02,
    borderWidth: 1,
    borderRadius: 10,
    backgroundColor: color.white,
    marginLeft: 40,
    marginTop: -4,
    justifyContent: "center",
  },
  itemDekhe: {
    paddingHorizontal: 12,
    paddingVertical: 7,
    borderRadius: 8,
    borderColor: color.black02,
  },
  itemDekheSubmitted: {
    borderWidth: 1,
    backgroundColor: color.white,
  },
  itemDekheActive: {
    borderWidth: 0,
    backgroundColor: color.greenHaze,
  },
  returnQuantity: { paddingHorizontal: 16, paddingBottom: 16 },
  newTagText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontWeight: "700",
    fontSize: 11,
    color: color.white,
    textAlign: "center",
  },
  newTag: {
    position: "absolute",
    left: -20,
    top: 3,
    height: 15,
    width: 60,
    alignItems: "center",
    justifyContent: "center",
    transform: [{ rotate: "-45deg" }],
    backgroundColor: color.newTagGreen,
  },
});
